import { fetcher } from "@repo/api";
import { useMemo } from "react";
import useSWR from "swr";

import { UserTourStateCalendar, UserTourStateDefault } from "./reducer";

interface Tour {
  createdAt: number;
  id: number;
  isTourCompleted: boolean;
  title: string;
  updatedAt: number;
}

export function useCompletedTour(currentTour: string) {
  const { data, isValidating } = useSWR<Tour[]>(
    `/coworkers/tour`,
    (url) => fetcher.core.get(url),
    {
      revalidateOnFocus: false,
    }
  );

  const tourData = useMemo(() => {
    if (!isValidating && data) {
      const lastTourData = data
        .filter((obj) => obj.title === currentTour)
        .pop();

      if (lastTourData?.isTourCompleted) {
        return false;
      }
    }

    return true;
  }, [currentTour, data, isValidating]);

  return { tourData, isValidating };
}

export const setCompletedTour = async (currentTour: string) => {
  const res = await fetcher.core.update(`/coworkers/tour`, {
    isTourCompleted: true,
    title: currentTour,
  });
  return res;
};

export const clearUserTour = async () => {
  await fetcher.core.update(`/coworkers/tour`, {
    isTourCompleted: false,
    title: UserTourStateDefault.currentTour,
  });

  await fetcher.core.update(`/coworkers/tour`, {
    isTourCompleted: false,
    title: UserTourStateCalendar.currentTour,
  });
};
